'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LocaleSelect = require('./LocaleSelect');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LocaleSelect).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }